
import { Loader } from "@googlemaps/js-api-loader"
import { getTenantDir } from "@/plugins/env"
const DEFAULT_POSITION = {
  LAT: 22.282998,
  LNG: 114.133834
}
const ZOOM_LEVEL = 15
export default {
  props: {
    servicesOptions: {
      type: Array,
      default: () => []
    },
    storeList: {
      type: Array,
      default: () => []
    },
    currentStoreId: {
      type: Number,
      default: null
    },
    services: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dir: null,
      Ison_Size: null,
      map: null,
      googlemaps: null,
      infoWindows: [],
      loader: new Loader({
        apiKey: this.$appConfig.googleMapApiKey,
        version: "weekly",
        libraries: ["places"]
      })
    }
  },
  computed: {
    currentStore() {
      return (
        this.storeList.find(item => item.storeId == this.currentStoreId) ||
        this.storeList?.[0] || {
          latitude: DEFAULT_POSITION.LAT,
          longitude: DEFAULT_POSITION.LNG
        }
      )
    }
  },
  watch: {
    currentStoreId() {
      this.infoWindows.forEach(infoWindow => {
        if (infoWindow.id != this.currentStoreId) {
          infoWindow.close()
        } else {
          infoWindow.open({
            anchor: infoWindow.marker,
            map: this.map
          })
        }
      })
      if (this.map) {
        this.map.setCenter({
          lat: this.currentStore.latitude,
          lng: this.currentStore.longitude
        })
      }
    }
  },
  mounted() {
    this.initMap()
    this.dir = getTenantDir()
  },
  methods: {
    async initMap() {
      const googlemaps = await this.loader.importLibrary("maps")
      const { Marker } = await this.loader.importLibrary("marker")
      const { Size } = await this.loader.importLibrary("core")
      this.Ison_Size = Size
      this.googlemaps = googlemaps
      this.Marker = Marker
      const mapOptions = {
        zoom: ZOOM_LEVEL,
        fullscreenControl: false,
        mapTypeControl: false,
        mapId: "4504f8b37365c3d0",
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP
        }
      }
      const obj = {
        center: { lat: this.currentStore.latitude, lng: this.currentStore.longitude },
        ...mapOptions
      }
      this.map = new this.googlemaps.Map(this.$refs.map, obj)
      this.addWellcomeMarker()
    },

    addWellcomeMarker() {
      const locations = this.storeList.map(item => {
        // 默认图标
        let icon = "store_marker.png"
        // 检查是否有 serviceIds，并进行处理
        if (item.serviceIds && item.serviceIds.length > 0) {
          const service = this.servicesOptions.find(val => val.value === Number(item.serviceIds[0]))
          if (service) {
            if (service.label === "Oliver's") {
              icon = "olivers.png"
            } else if (service.label === "3hreesixty") {
              icon = "3hreesixty.png"
            }
          }
        }
        // 返回标记点对象
        return {
          lat: item.latitude,
          lng: item.longitude,
          id: item.storeId,
          icon // 设置相应的图标
        }
      })
      locations.forEach(location => {
        // 为每个位置创建标记
        this.addMarker(location)
      })
      if (this.infoWindows.length > 0) {
        this.infoWindows[0].open({
          anchor: this.infoWindows[0].marker,
          map: this.map
        })
      }
    },
    getServiceImgUrl(id) {
      return this.services.find(item => item.id == id)?.imgUrl
    },
    addMarker(location) {
      const marker = new this.Marker({
        position: location,
        map: this.map,
        // icon: this.$webHelper.getImgUrl(`${location.icon}`) // 默认商店图标
        icon: {
          url: this.$webHelper.getImgUrl(location.icon),
          scaledSize: new this.Ison_Size(40, 46) // 统一设置图标大小
        }
      })
      const storeInfo = this.storeList.find(item => item.storeId == location.id)
      let imgs = ""
      let serviceTemplate = ""
      if (storeInfo.serviceIds) {
        imgs = storeInfo.serviceIds
          .map(id => {
            const imgUrl = this.getServiceImgUrl(id)
            return imgUrl ? `<img src="${imgUrl}" alt="service" class="service-img" />` : ""
          })
          .join("")
      }
      if (imgs && this.dir !== "mpj") {
        serviceTemplate = `
        <div class="title">Service</div>
        <div class="info group-wrapper">
          <div class="group">
            ${imgs}
          </div>
        </div>
        `
      }

      let telTemplate = ""
      const iconColor = this.$webHelper.getIconColor()
      if (storeInfo.tel) {
        telTemplate = `
        <span>
         <svg class="icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.40399 0.479405C1.83199 0.710072 1.45199 1.08074 0.894653 1.77941C-0.490014 3.51741 0.747986 6.97941 3.93732 10.1421L4.10265 10.3041C7.10265 13.1881 10.8993 14.4374 12.348 13.1801L12.3953 13.1361L12.3727 13.1547C12.7858 12.821 13.1263 12.4063 13.3733 11.9361C13.8913 10.9361 13.7507 9.89141 12.73 9.0774C11.2607 7.90541 10.274 7.86541 9.30132 8.75741L9.19199 8.86007L8.91065 9.13874C8.78865 9.11341 8.59999 9.02407 8.36799 8.87474C7.90532 8.57607 7.32865 8.07941 6.67132 7.42807C6.01599 6.77741 5.51399 6.20607 5.21332 5.74674L5.15265 5.65141C5.07417 5.52986 5.00997 5.39966 4.96132 5.26341L4.94665 5.21007L5.22999 4.93007L5.33332 4.82141C6.23132 3.85674 6.19132 2.87807 5.01065 1.42074C4.20865 0.430739 3.29732 0.118739 2.40399 0.479405ZM3.96532 2.25274L4.14065 2.47274C4.72732 3.23341 4.73265 3.48607 4.39665 3.86741L4.26665 4.00607L3.93665 4.33141C3.22599 5.03541 3.54199 5.93007 4.59065 7.16274L4.81065 7.41407L5.04865 7.67474L5.17532 7.80807L5.44065 8.08341L5.72465 8.36874L5.86932 8.5114L6.15199 8.78407L6.42399 9.03874C6.51332 9.12007 6.60065 9.19874 6.68665 9.27474L6.93999 9.49207C8.18399 10.5321 9.08399 10.8447 9.79465 10.1434L10.1233 9.8154L10.21 9.73341C10.5893 9.38674 10.824 9.33807 11.4713 9.7954L11.668 9.94007L11.8907 10.1134C12.3787 10.5027 12.426 10.8567 12.1813 11.3287C12.0682 11.5378 11.9269 11.7302 11.7613 11.9007L11.648 12.0154L11.5613 12.0954L11.478 12.1681C11.2527 12.3914 10.386 12.4127 9.27199 12.0474C7.85465 11.5821 6.30332 10.6087 4.88532 9.20207C2.11799 6.4574 1.11332 3.64874 1.94532 2.60407C2.35865 2.08541 2.62732 1.82407 2.90865 1.71074C3.20999 1.58874 3.51132 1.69207 3.96532 2.25274Z" fill="${iconColor}"/>
        </svg>
          <span>${storeInfo.tel}</span>
        </span>
        `
      }

      const contentString = `
  <div class="store-locator-store-info" style="width: 3rem;">
    <div>
      <div class="name">${storeInfo.storeName}</div>
      <div class="address">${storeInfo.storeAddress}</div>
    </div>
    <div>
       <div class="title">${telTemplate}</div>
    </div>
    <div>
      <div class="title">
            <div>
         <svg class="icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.7841 3.27791C11.6434 3.41883 11.4524 3.49802 11.2533 3.49802L9.25001 3.49805C8.8358 3.49806 8.50001 3.16228 8.5 2.74806C8.49999 2.33385 8.83578 1.99806 9.24999 1.99805L9.46966 1.99805C9.39751 1.96544 9.32327 1.9387 9.24877 1.91187C9.18379 1.88847 9.11861 1.86499 9.05448 1.8375C8.48363 1.59277 7.79631 1.49805 7.05 1.49805C3.94864 1.49805 1.5 3.87851 1.5 6.94999C1.5 10.0529 3.88006 12.502 6.95 12.502C10.0356 12.502 12.5 10.0371 12.5 6.94999C12.5 6.21642 12.4089 5.6241 12.1606 5.04466C11.9975 4.66392 12.1739 4.22303 12.5546 4.05991C12.9354 3.89678 13.3656 4.04838 13.5394 4.45394C13.8911 5.27494 14 6.08306 14 6.94999C14 10.8651 10.8644 14.002 6.95 14.002C3.01994 14.002 0 10.8493 0 6.94999C0 3.01927 3.15136 -0.00195211 7.05 -0.00195211C7.89321 -0.00195211 8.79399 0.100821 9.61497 0.44588C9.90694 0.542267 10.2659 0.718743 10.5002 0.876192L10.5 0.749279C10.4993 0.335066 10.8346 -0.00126958 11.2488 -0.00195211C11.663 -0.00262658 11.9993 0.332609 12 0.746822L12.0033 2.74679C12.0036 2.94591 11.9247 3.13699 11.7841 3.27791Z" fill="${iconColor}"/>
        <path d="M7 4C7.41421 4 7.75 4.33579 7.75 4.75V7.01794C7.75 7.18067 7.82919 7.33322 7.96227 7.42686L9.68159 8.63663C10.0203 8.87499 10.1017 9.34283 9.86338 9.68159C9.62502 10.0203 9.15717 10.1017 8.81841 9.86338L6.56841 8.28021C6.36878 8.13974 6.25 7.91092 6.25 7.66683V4.75C6.25 4.33579 6.58579 4 7 4Z" fill="${iconColor}"/>
        </svg>
        <span>${this.$t("storeLocator.openingHours")}</span>
      </div>

          <span>${storeInfo.openingHours.replace(/\n/g, "<br />")}</span>
        </span>
      </div>
    </div>
    <div>
      ${serviceTemplate}
      <a class="direction" target="_blank" href="https://www.google.com/maps/dir/Current+Location/${
        storeInfo.storeAddress
      }">
      ${this.$t("storeLocator.getDirections")}
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.3333 7.99622C11.3333 8.10884 11.3083 8.22147 11.2666 8.32543C11.2165 8.43805 11.1498 8.53335 11.0663 8.61999L5.99333 13.7661C5.85149 13.922 5.65958 14 5.45099 14C5.30914 14 5.17564 13.9653 5.05883 13.896C4.94202 13.8267 4.85024 13.7228 4.77514 13.6101C4.70005 13.4889 4.66668 13.3502 4.66668 13.203C4.66668 12.9777 4.75011 12.7698 4.90864 12.6138L9.47268 7.99622L4.90865 3.37859C4.75846 3.23131 4.66668 3.01472 4.66668 2.79814C4.66668 2.65086 4.70005 2.51224 4.77515 2.39095C4.8419 2.26967 4.94202 2.17437 5.05883 2.10506C5.17565 2.03575 5.31749 1.99243 5.45099 2.0011C5.65124 2.0011 5.85149 2.07907 5.99333 2.23501L11.0663 7.37245C11.1498 7.45042 11.2165 7.55438 11.2666 7.65834C11.3083 7.7623 11.3333 7.88359 11.3333 7.99622Z" fill="${iconColor}"/>
      </svg>

      </a>
    </div>
  </div>
     `

      const infowindow = new this.googlemaps.InfoWindow({
        content: contentString,
        shouldFocus: true,
        id: location.id
      })
      infowindow.marker = marker

      marker.addListener("click", event => {
        this.closeInfoWindows()
        this.$emit("change", infowindow.id)
        infowindow.open({
          anchor: marker,
          map: this.map,
          shouldFocus: true
        })
      })
      this.infoWindows.push(infowindow)
    },
    closeInfoWindows() {
      this.infoWindows.forEach(infoWindow => {
        infoWindow.close()
      })
    }
  }
}
